module.exports = __webpack_public_path__ + "img/5.aba78da5.jpg";